import {Component} from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    public lang;

    constructor(public router: Router) {
      if (typeof(window) !== 'undefined') {

        if (localStorage.getItem('lang') === null) {
          localStorage.setItem('lang', 'es');
          this.lang = 'es';
        } else {
          this.lang = localStorage.getItem('lang');
        }
      } else {
        const temp = this.router.url.split('/');
        localStorage.setItem('lang', this.lang);
        this.lang = temp[1];
      }
    }
}
